import { Grid } from '@material-ui/core';
import Box from '@mui/material/Box';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import RejectInformation from '../components/CandidatesTab/Modals/RejectInformation';
import BodyCandidate from '../components/Collaborator/BodyCandidate';
import '../components/Collaborator/Collaborator.css';
import CollaboratorState from '../context/CollaboratorContext/CollaboratorState';
import AvisoPrivacidad from '../components/CandidatesTab/Modals/AvisoPrivacidad';

const CandidateScreen = () => {
    const params = useParams<any>();
    const [title, setTitle] = useState('INFORMACIÓN DE ALTA ')

    const UsuarioAcepta = localStorage.getItem('UsuarioAcepta')


    useEffect(() => {
        switch (params?.tab) {
            case '1':
                setTitle('INFORMACIÓN DE ALTA');
                break;
            case '2':
                setTitle('DATOS PERSONALES');
                break;
            case '3':
                setTitle('SALUD Y EMERGENCIAS');
                break;
            case '4':
                setTitle('DATOS BANCARIOS');
                break;
            case '5':
                setTitle('EXPEDIENTE');
                break;
        }
    }, [params]);
    return (
        <Box>
            <Box boxShadow={0} mt={1} ml={2} mr={2}>
                <div className="Header__Candidate">
                    <img src="/assets/svg/logo-bits.svg" height="50" alt="BITS" />
                    <Grid direction="row" container justify="center" alignItems="center">
                        <h1>{title}</h1>
                        { UsuarioAcepta !== 'Acepta'
                        ? (
                        <AvisoPrivacidad />
                        ): null
                        }
                    </Grid>
                </div>
            </Box>
            <Box boxShadow={0} m={2}>
                <CollaboratorState>
                    <BodyCandidate />
                    <RejectInformation/>
                </CollaboratorState>
            </Box>
        </Box>
    );
}

export default CandidateScreen;